import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator, BreadcrumbPage } from '../components/ui/breadcrumb';
import SEO from '../components/SEO';

const CGVPage = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="cgv-page">
      <SEO 
        title="Conditions Générales de Vente | Atlantique Spa Boutique"
        description="Conditions générales de vente pour l'achat de spas, pièces détachées, accessoires et pompes à chaleur sur Atlantique Spa Boutique."
        canonical="/cgv"
      />
      
      {/* Breadcrumb */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/">Accueil</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Conditions Générales de Vente</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Conditions Générales de Vente</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-8">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 1 - Objet</h2>
            <p className="text-slate-600 leading-relaxed">
              Les présentes Conditions Générales de Vente (CGV) régissent les ventes de produits effectuées par Atlantique Spa Boutique 
              via son site internet, notamment : spas, pièces détachées, accessoires, produits d'entretien et pompes à chaleur pour spa.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 2 - Prix</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les prix des produits sont indiqués en euros, toutes taxes comprises (TTC).
            </p>
            <p className="text-slate-600 leading-relaxed">
              Atlantique Spa Boutique se réserve le droit de modifier ses prix à tout moment. Les produits sont facturés 
              sur la base des tarifs en vigueur au moment de la validation de la commande.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 3 - Commande</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              La validation d'une commande implique l'acceptation intégrale des présentes CGV. Pour les spas, 
              la commande fait l'objet d'une demande de devis préalable et d'un accompagnement personnalisé.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Les pièces détachées, accessoires, produits d'entretien et pompes à chaleur peuvent être commandés directement en ligne.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 4 - Livraison</h2>
            <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-4">
              <p className="text-emerald-800 font-medium">🚚 Livraison offerte dès 80 € TTC</p>
              <p className="text-emerald-700 text-sm mt-1">
                Les frais de livraison sont offerts pour toute commande d'un montant égal ou supérieur à 80 € TTC, 
                pour une livraison en France métropolitaine.
              </p>
            </div>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les produits (pièces détachées, accessoires, produits d'entretien, pompes à chaleur) sont livrés en France métropolitaine. 
              En dessous de 80 € TTC, les frais de livraison sont calculés lors de la validation du panier.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les délais de livraison sont généralement de 48 à 72h selon la disponibilité des produits.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>Pour les spas :</strong> la livraison fait l'objet d'une organisation spécifique. L'installation peut être proposée 
              dans certaines zones géographiques (Loire-Atlantique 44, Vendée 85, Morbihan 56, Maine-et-Loire 49). 
              En dehors de ces zones, le spa est livré prêt à être installé.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Le client s'engage à vérifier l'état du colis à la livraison et à signaler toute anomalie au transporteur.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 5 - Compatibilité des produits</h2>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
              <p className="text-amber-800 font-medium">Important</p>
            </div>
            <p className="text-slate-600 leading-relaxed mb-4">
              Il appartient au client de vérifier la compatibilité des pièces détachées et accessoires avec son équipement 
              avant toute commande. Les commandes sont préparées sur la base des références choisies par le client.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              Pour les pompes à chaleur, une étude personnalisée est fortement recommandée afin de vérifier la compatibilité 
              avec le spa (volume, configuration, emplacement, environnement). Cette étude est proposée mais reste optionnelle.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Atlantique Spa Boutique ne saurait être tenu responsable d'une erreur de commande due à un mauvais choix de référence 
              ou à un défaut de vérification de compatibilité de la part du client.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 6 - Droit de rétractation</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Conformément aux dispositions légales en vigueur, le client dispose d'un délai de 14 jours à compter de 
              la réception du produit pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              Pour exercer ce droit, le client doit notifier sa décision par écrit à Atlantique Spa Boutique. 
              Le produit doit être retourné dans son état et emballage d'origine, non utilisé et non installé.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Les frais de retour sont à la charge du client. Le remboursement sera effectué dans un délai de 14 jours 
              suivant la réception du produit retourné.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 7 - Retours et échanges</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les conditions de retour dépendent de l'état du produit et de la nature de l'erreur. 
              Tout retour doit faire l'objet d'une demande préalable auprès de notre service client.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Les produits retournés incomplets, abîmés, endommagés ou salis par le client ne seront pas repris.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 8 - Garanties et exclusions</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les produits vendus sur ce site bénéficient des garanties suivantes, sous réserve d'une utilisation conforme :
            </p>
            <ul className="text-slate-600 leading-relaxed mb-4 list-disc list-inside space-y-1">
              <li>Garantie pièces et main-d'œuvre : <strong>2 ans</strong></li>
              <li>Garantie coque : <strong>5 ans</strong></li>
              <li>Garantie coque acrylique : <strong>5 ans</strong></li>
              <li>Garantie structure du spa : <strong>10 ans</strong></li>
            </ul>
            
            <p className="text-slate-600 leading-relaxed mb-3 font-semibold">
              Sont expressément exclus de ces garanties :
            </p>
            
            <p className="text-slate-600 leading-relaxed mb-2">
              <strong>a) Les éléments soumis à usure normale, dont notamment :</strong>
            </p>
            <ul className="text-slate-600 leading-relaxed mb-4 list-disc list-inside space-y-1 ml-4">
              <li>appuie-têtes et coussins</li>
              <li>cartouches et éléments filtrants</li>
              <li>jets non structurels</li>
              <li>sangles, clips, attaches, sangles de couverture</li>
            </ul>
            
            <p className="text-slate-600 leading-relaxed mb-2">
              <strong>b) Les accessoires et pièces non structurelles :</strong>
            </p>
            <ul className="text-slate-600 leading-relaxed mb-4 list-disc list-inside space-y-1 ml-4">
              <li>plateaux bar et supports d'accessoires</li>
              <li>échelles / marches d'accès</li>
              <li>composants décoratifs</li>
            </ul>
            
            <p className="text-slate-600 leading-relaxed mb-2">
              <strong>c) Les produits consommables :</strong>
            </p>
            <ul className="text-slate-600 leading-relaxed mb-4 list-disc list-inside space-y-1 ml-4">
              <li>produits de traitement de l'eau</li>
              <li>nettoyants et autres consommables</li>
            </ul>
            
            <p className="text-slate-600 leading-relaxed mb-2">
              <strong>d) Toute défaillance résultant d'une :</strong>
            </p>
            <ul className="text-slate-600 leading-relaxed mb-4 list-disc list-inside space-y-1 ml-4">
              <li>mauvaise installation</li>
              <li>utilisation non conforme</li>
              <li>absence d'entretien régulier</li>
              <li>modification du produit</li>
            </ul>
            
            <p className="text-slate-600 leading-relaxed">
              Le client est invité à consulter la documentation produit et à suivre les recommandations du fabricant. 
              La garantie ne couvre pas les dommages causés par un usage abusif, une installation non conforme ou 
              des circonstances indépendantes de la qualité de fabrication.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 9 - Service après-vente</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les interventions techniques, réparations et maintenances sont assurées via notre structure spécialisée : 
              <a href="https://www.atlantiquespaservice.com" target="_blank" rel="noopener noreferrer" className="text-[#1E3A5F] hover:underline ml-1">
                atlantiquespaservice.com
              </a>
            </p>
            <p className="text-slate-600 leading-relaxed">
              Les zones d'intervention pour le SAV sont principalement : Loire-Atlantique (44), Vendée (85), 
              Morbihan (56) et Maine-et-Loire (49).
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 10 - Responsabilité</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Atlantique Spa Boutique ne saurait être tenu responsable des dommages résultant d'une mauvaise utilisation 
              du produit, d'une installation non conforme ou d'un défaut d'entretien.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Le client est responsable de l'installation électrique et hydraulique nécessaire au fonctionnement du spa, 
              qui doit être conforme aux normes en vigueur.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 11 - Données personnelles</h2>
            <p className="text-slate-600 leading-relaxed">
              Les données personnelles collectées sont nécessaires au traitement des commandes et à la relation client. 
              Elles sont traitées conformément à notre politique de confidentialité, consultable sur notre site.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 12 - Litiges</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée 
              avant toute action judiciaire.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Conformément aux dispositions du Code de la consommation concernant le règlement amiable des litiges, 
              le client peut recourir gratuitement au service de médiation.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 13 - Contact</h2>
            <p className="text-slate-600 leading-relaxed">
              Pour toute question relative aux présentes CGV, vous pouvez nous contacter :<br />
              Email : contact@atlantiquespaboutique.com<br />
              Email : contact@atlantiquespaboutique.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGVPage;
